import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { ThemeProvider } from './theme/ThemeProvider';
import { APP_VERSION } from './version';
import './i18n';
import './index.css';

// Make the running build's version discoverable: logged to the console and
// exposed as <html data-app-version="…"> for quick inspection / smoke checks.
console.info(`kstefan web ${APP_VERSION}`);
document.documentElement.dataset.appVersion = APP_VERSION;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
